import { useMemo, useCallback } from "react";
import { useHistory, useLocation } from "react-router";
import querystring from "querystring";

const useLocationParams = () => {
	const { search = "", state = {} } = useLocation();
	const history = useHistory();

	const param = useMemo(() => querystring.parse(search.substr(1)), [search]);

	const historyParams = useCallback(
		(newParams, state, path) => {
			newParams = Object.assign(param, newParams);
			newParams = Object.keys(newParams)
				.filter((key) => newParams[key])
				.reduce((res, key) => Object.assign(res, { [key]: newParams[key] }), {});

			history.push({ search: `?${querystring.stringify(newParams)}`, state, pathname: path });
		},
		[param, history],
	);

	const setParam = useCallback(
		(key, value) => {
			historyParams({ [key]: value });
		},
		[historyParams],
	);

	return {
		search,
		param,
		state,
		historyParams,
		setParam,
	};
};

export default useLocationParams;
